import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { ButtonPrimary } from '@comeon/ui';

import useRegistration from '~/components/authentication/register/use-register';
import useConfiguration from '~/configuration/use-configuration';
import {
	selectOneBankIDFlowEnabled,
	selectOneButtonFlow,
	selectIsRegistrationBlocked
} from '~/components/brand/ducks/selectors';
import useTranslations from '~/components/translation/use-translations';

import PlayAsGuestButton from './play-as-guest-button';
import useGuestLogin from '~/components/guest-login/hooks/use-guest-login';

/// / FIXME: get z index from function.
const UnauthWrapper = styled.div`
	background-color: var(--sign-in-box, rgba(var(--base-10), 1));
	border-top: 1px solid var(--sign-in-box-border, rgba(var(--base-09), 1));
	bottom: ${({ hasBottomOffset, displayGlobalNavigation }) =>
		hasBottomOffset
			? displayGlobalNavigation
				? 'var(--bottomNavHeight)'
				: 'var(--unauth-header-position, 0)'
			: 0};
	display: flex;
	left: 0;
	padding: 12px;
	position: ${({ displayGlobalNavigation }) => (displayGlobalNavigation ? 'fixed' : 'absolute')};
	width: 100vw;
	z-index: 3;
	gap: 12px;
`;

const killEvent = e => {
	if (e) {
		e.stopPropagation();
		e.preventDefault();
	}
};

export const UnauthenticatedHeaderSmall = ({
	showLoginAsGuestOption,
	createAccountTitleText,
	oneBankIDFlowEnabled,
	oneButtonFlow,
	hasBottomOffset,
	displayGlobalNavigation
}) => {
	const { pathname } = useLocation();
	const { redirectToRegister } = useRegistration();
	const handleRegisterClick = e => {
		killEvent(e);
		redirectToRegister({
			from: pathname
		});
	};
	return (
		<UnauthWrapper
			data-at="mobile-wrapper-navbar"
			className="unauthenticated-header button-wrapper"
			hasBottomOffset={hasBottomOffset}
			displayGlobalNavigation={displayGlobalNavigation}
		>
			<ButtonPrimary dataAt="open-account-navbar" onClick={handleRegisterClick}>
				{createAccountTitleText}
			</ButtonPrimary>
			{!oneBankIDFlowEnabled && !oneButtonFlow && showLoginAsGuestOption && (
				<PlayAsGuestButton dataAt="pag-navbar" />
			)}
		</UnauthWrapper>
	);
};

export const NoAccountUnauthenticatedHeaderSmall = ({
	text,
	onClick,
	blackFridayCampaignEnabled,
	hasBottomOffset,
	displayGlobalNavigation
}) => {
	return (
		<UnauthWrapper
			className="unauthenticated-header"
			hasBottomOffset={hasBottomOffset}
			displayGlobalNavigation={displayGlobalNavigation}
		>
			<ButtonPrimary
				dataAt="open-account-navbar"
				onClick={onClick}
				bg={
					blackFridayCampaignEnabled
						? 'rgba(var(--base-12), 1)'
						: 'var(--button-primary-bg, rgba(var(--primary), 1))'
				}
			>
				{text}
			</ButtonPrimary>
		</UnauthWrapper>
	);
};

const MOBILE_PLAY_NOW = 'MOBILE_PLAY_NOW';
const MOBILE_TRUSTLY_DEPOSIT_LOGIN = 'MOBILE_TRUSTLY_DEPOSIT_LOGIN';
const MOBILE_LOGIN_REGISTRATION = 'MOBILE_LOGIN_REGISTRATION';
const MOBILE_PAG_LOGIN = 'MOBILE_PAG_LOGIN';

const UNAUTH_HEADER_TEXT_KEYS = [
	'MOBILE_LOGIN_LOGIN_BUTTON',
	MOBILE_PAG_LOGIN,
	MOBILE_LOGIN_REGISTRATION,
	MOBILE_TRUSTLY_DEPOSIT_LOGIN,
	MOBILE_PLAY_NOW
];

export const UnauthenticatedHeader = ({ ButtonRegister }) => {
	const location = useLocation();
	const { showLoginAsGuestOption, useTrustlyLogin, isAnonymous } = useConfiguration();
	const { redirectToGuestLogin } = useGuestLogin();
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlow);
	const isDanishFranchise = useSelector(state => state.brand?.isDanishFranchise);

	const { translations: tr, isLoadingTranslations } = useTranslations(UNAUTH_HEADER_TEXT_KEYS);
	const buttonTextKey =
		oneBankIDFlowEnabled || oneButtonFlow
			? MOBILE_PLAY_NOW
			: isAnonymous
				? MOBILE_TRUSTLY_DEPOSIT_LOGIN
				: MOBILE_LOGIN_REGISTRATION;

	const { redirectToRegister } = useRegistration();
	const handleRegisterClick = e => {
		killEvent(e);
		if (isAnonymous) {
			redirectToGuestLogin();
		} else {
			redirectToRegister({
				from: location
			});
		}
	};
	// FIXME THis is getting too hacky!!!
	const isRegistrationBlocked = useSelector(selectIsRegistrationBlocked);
	if (isRegistrationBlocked) {
		return null;
	}

	return (
		!isLoadingTranslations && (
			<>
				<ButtonRegister
					small="true"
					className="u-mr1"
					onClick={handleRegisterClick}
					dataAt={useTrustlyLogin ? 'deposit-button-trustlydeplogin' : 'open-account-header'}
				>
					{tr[buttonTextKey]}
				</ButtonRegister>
				{!oneBankIDFlowEnabled && !isDanishFranchise && showLoginAsGuestOption && (
					<PlayAsGuestButton small="true" dataAt="pag-header" className="u-mr1" />
				)}
			</>
		)
	);
};
